import '../vendor/bootstrap.scss'
import './index.scss'
import $ from 'jquery'
import 'owl.carousel'
import '../vendor/bootstrap'
import { setUpAuthModals } from '../components/auth-modals'
import { setUpFooter } from '../components/footer'
// import setCountdown from './components/cdi-voucher'

const isVisible = ($el) => {
  const winTop = $(window).scrollTop()
  const winBottom = winTop + $(window).height()
  const elTop = $el.offset().top + 250
  return elTop <= winBottom && elTop >= winTop
}

const showSidebar = () => {
  $('.js-sidebar-container')
    .fadeIn()
    .addClass('mobile-display d-block position-fixed')
  $('.js-close-sidebar').remove('d-none').addClass('d-flex')
  $('body').addClass('visible-sidebar')
}

const closeSidebar = () => {
  $('.js-close-sidebar').addClass('d-none').removeClass('d-flex')
  $('body').removeClass('visible-sidebar')
  $('.js-sidebar-container').fadeOut('fast', () => {
    $('.js-sidebar-container').removeClass(
      'mobile-display d-block position-fixed'
    )
  })
}

const animateScrollTo = (ancor) => {
  const target = $('*[data-scroll-anchor=' + ancor + ']')
  if (target.length === 0) {
    return
  }
  $('html').animate(
    {
      scrollTop: target.offset().top - 75
    },
    1000,
    () => {
      if (!isVisible(target)) {
        animateScrollTo(ancor)
      }
    }
  )
}

const collapseCourse = () => {
  $('.no-experience-course').each((_, el) => {
    const courseSlug = $(el).data('scroll-anchor')
    $('*[data-scroll-to="' + courseSlug + '"]').removeClass('.hovered')
    $(el).find('.collapse-container').collapse('hide').addClass('collapsed')
  })
}

const expandCourse = () => {
  $('.no-experience-course').each((_, el) => {
    $(el).find('.collapse-container').collapse('show')
  })
}

const setNoExperienceCourseState = (shouldExpand) => {
  return shouldExpand ? expandCourse() : collapseCourse()
}

$(() => {
  setUpAuthModals()
  setUpFooter()

  $('form[action="/checkout/profile"] input[name="redir"]').val(
    window.location.pathname
  )

  const checkBox = $('#checkbox_view_courses')
  const initialSetup = checkBox.length ? checkBox.data('show-courses') : true
  if (checkBox.length) {
    checkBox.prop('checked', !checkBox.data('show-courses'))
  }
  setNoExperienceCourseState(initialSetup)

  checkBox.on('change', () => {
    const viewNoExperienceCourses = !checkBox.is(':checked')
    $.ajax({
      url: '/checkout/profile/view-courses',
      method: 'POST',
      data: { viewNoExperienceCourses },
      success: () => {
        setNoExperienceCourseState(viewNoExperienceCourses)
      },
      error: (err) => {
        // eslint-disable-next-line no-console
        console.log('checkBox.on error', err)
      }
    })
  })

  $('.js-sidebar-item').on('click', (e) => {
    const anchor = $(e.target).data('scroll-to')
    if ($('body').hasClass('visible-sidebar')) {
      closeSidebar()
    }
    animateScrollTo(anchor)
  })

  $('.start-course').on('click', (e) => {
    e.preventDefault()
    const anchor = $('.no-experience-course').first().data('scroll-anchor')
    animateScrollTo(anchor)
  })

  $('.js-scroll-link').on('click', (e) => {
    const anchor = $(e.currentTarget).data('scroll-to')
    animateScrollTo(anchor)
  })

  $('.js-close-sidebar').on('click', () => {
    closeSidebar()
  })

  $('.js-sidebar-toggle').on('click', () => {
    showSidebar()
  })

  window.addEventListener('scroll', () => {
    if ($(window).innerWidth() < 991) {
      return
    }
    $('*[data-scroll-anchor]')
      .not('.collapsed')
      .each((i, el) => {
        const anchor = $(el).data('scroll-anchor')
        if (isVisible($(el))) {
          $('li[data-scroll-to=' + anchor + ']').addClass('hovered')
        } else {
          $('li[data-scroll-to=' + anchor + ']').removeClass('hovered')
        }
      })
  })

  $('.chapters-slider')
    .owlCarousel({
      center: true,
      loop: false,
      margin: 10,
      nav: true,
      dots: true,
      responsive: {
        0: {
          items: 1
        },
        525: {
          items: 1
        }
      }
    })
    .on('changed.owl.carousel', () => {
      setTimeout(() => {
        $('.owl-first-or-last').removeClass('owl-first-or-last')
        $('.owl-item.active:first').addClass('owl-first-or-last')
        $('.owl-item.active:last').addClass('owl-first-or-last')
      }, 1)
    })
  $('.owl-item.active:first').addClass('owl-first-or-last')
  $('.owl-item.active:last').addClass('owl-first-or-last')
  $('.owl-nav .owl-prev').html(
    '<i class="fa fa-chevron-circle-left fa-2x"></i>'
  )
  $('.owl-nav .owl-next').html(
    '<i class="fa fa-chevron-circle-right fa-2x"></i>'
  )
})
